export default {
  // Payment Result Success
  successTitle: 'تمت عملية الدفع بنجاح!',
  successMessage: 'تمت معالجة عملية الدفع بنجاح.',
  congratulations: 'تهانينا',
  policyIssuedSuccessfully: 'تم إستخراج وثيقة التأمين ضد الأخطاء الطبية بنجاح',
  successPaymentBy: 'تمت عملية الدفع بنجاح عن طريق',
  tamaraPaymentMessage:
    'تحقق من بريدك الإلكتروني للاستمتاع بباقة الخدمات الذكية الخاصة بك',
  tabbyPaymentMessage:
    'تحقق من بريدك الإلكتروني للاستمتاع بباقة الخدمات الذكية الخاصة بك',
  paymentMethod: 'طريقة الدفع',
  policyNumber: 'رقم الوثيقة',
  policyEffectiveDate: 'تاريخ بدء الوثيقة',
  policyExpiryDate: 'تاريخ انتهاء الوثيقة',
  policyDuration: 'فترة التأمين',
  totalPremium: 'التكلفة الإجمالية',
  includesTaxesAndFees: 'السعر شامل الضريبة والرسوم',
  policyholderDetails: 'إسم حامل الوثيقة',
  name: 'الاسم',
  identityNumber: 'هوية حامل الوثيقة',
  specialty: 'التخصص الطبي',
  placeOfPractice: 'مكان الممارسة',
  coverage: 'التغطية',
  policyLimit: 'حدود تغطية التأمين',
  deductible: 'نسبة/قيمة التحمل',
  retroactiveCover: 'التغطية بأثر رجعي',
  extendedReportingPeriod: 'منفعة تمديد مدة التبليغ عن المطالبات',
  features: 'المزايا',
  benefitsDescription: 'الفوائد المدرجة في وثيقتك',
  emailNotVerified: 'البريد الإلكتروني غير مُتحقق منه',
  verifyEmailMessage:
    'البريد الإلكتروني لم يتم التحقق منه بعد، يرجى التحقق لتلقي مستندات الوثيقة',
  verifyEmail: 'للتحقق من بريدك الإلكتروني اضغط هنا',
  printPolicy: 'طباعة الوثيقة',
  printReceipt: 'طباعة إيصال الدفع',
  backToHome: 'العودة للصفحة الرئيسية',
  startNewRequest: 'بدء طلب جديد',
  policyInfo: 'معلومات الوثيقة',

  // Email Verification
  emailVerificationTitle: 'التحقق من البريد الإلكتروني',
  emailVerificationMessage: 'يرجى إدخال رمز التحقق المرسل إلى بريدك الإلكتروني',
  verificationCode: 'رمز التحقق',
  verifyEmailButton: 'التحقق من البريد الإلكتروني',
  emailVerifiedSuccess: 'تم التحقق من البريد الإلكتروني بنجاح',
  enterVerificationCode: 'أدخل رمز التحقق',

  // Missing translations
  quoteReference: 'الرقم المرجعي للتسعيرة',
  dateOfBirth: 'تاريخ الميلاد',
  qualification: 'المؤهلات الدراسية (العلمية)',
  insuranceCompany: 'شركة التأمين المُصدرة للوثيقة',

  // Payment Result Sadad Success
  sadadSuccessTitle: 'شكرا لإختيارك عرض السعر لتأمين الأخطاء الطبية',
  sadadBillDetails: 'تفاصيل الفاتورة',
  billerName: 'اسم المفوتر',
  billerCode: 'رمز المفوتر',
  billNumber: 'رقم الفاتورة',
  expiryDate: 'تاريخ ووقت إنتهاء الفاتورة',
  invoiceNumber: 'رقم الفاتورة',
  amount: 'المبلغ',
  currency: 'ريال',
  years: 'سنوات',
  year: 'سنة',
  sadadPaymentMessage: 'الرجاء الاطلاع على تفاصيل فاتورة سداد',
  paymentExpiryNote: 'لتجنب إلغاء عرض السعر، يرجى السداد قبل إنتهاء الفاتورة',

  // Payment Result Failure
  failureTitle: 'فشلت عملية الدفع',
  failureMessage: 'يرجى التحقق من طريقة الدفع والمحاولة مرة أخرى لاحقاً',
  tryAgain: 'حاول مرة أخرى',
  contactSupport: 'تواصل مع الدعم',

  // Benefits Section
  benefitsHeaderContent:
    'تمت إضافة {{count}} فوائد بنجاح! المزيد من الفوائد متاحة لمدة أطول..',
  benefitsSectionDescription:
    'الفوائد التي ستحصل عليها لمدة {{years}} سنوات أو أكثر.',

  // Common
  loading: 'جاري التحميل...',
  error: 'خطأ',
  somethingWentWrong: 'حدث خطأ ما',

  // New translations
  nameInEnglish: 'الاسم باللغة الإنجليزية',
  nameInArabic: 'الاسم باللغة العربية',

  // New loading-related translations
  waitPendingPayment: 'يرجى الانتظار!',
  processingPayment: 'جاري معالجة عملية الدفع..',
  dontCloseBrowser:
    'يرجى عدم إغلاق هذه النافذة أو النقر على زر الرجوع في المتصفح',

  // New translations from the code block
  pleaseWait: 'يرجى الانتظار',

  // Policy issuance status messages
  policyIssuanceInProgress: 'جاري إستخراج وثيقة التأمين',
  policyIssuanceTimeoutMessage:
    'جاري العمل على جلب وثيقة التأمين، وسوف يتم إرسالها عن طريق البريد الإلكتروني و الرسائل النصية للجوال المُسجَل',

  // Referral Section
  referAndEarn: 'أرسل دعوة واربح',
  referralDescription:
    'ستحصل على {{earningPoints}} نقطة مقابل كل {{equivalentRiyal}} ريال يتم شراؤه من قبل معارفك لتأمين الأخطاء الطبية',
  shareReferralLink: 'مشاركة رابط الدعوة',

  // Referral Consent Modal
  referralConsentCheckbox: 'أقر بفهمي لطريقة تنظيم برنامج المشاركة',
  referralConsentAccept: 'موافق وإنشاء الرابط',
  referralTermsAndConditions:
    'من خلال انضمامك  في برنامج المشاركة، فإنك توافق على الشروط والأحكام الخاصة بنا. يرجى القراءة بعناية قبل المتابعة.',
  generatingLink: 'جاري إنشاء الرابط...',
  shareYourLink: 'مشاركة الرابط الخاص بك',
  done: 'تم',
  referralLinkGenerated: 'تم إنشاء رابط المشاركة!',
  referralLinkMessage: 'شارك هذا الرابط مع أصدقائك وابدأ في كسب النقاط.',
  copy: 'نسخ',
  downloadTermsAndConditions: 'تحميل الشروط والأحكام',
  documentUnavailable: 'المستند غير متوفر',
  checkYourRewards: 'تفقد مكافآتك !',
} as const
